
export const convenios_item = [
    {

        "icono": "Servicios1.png",
        "nombre": "Servicios",
        "url": "/pdf/Convenios/Servicios.pdf"

    },
    {

        "icono": "Laboratorios.png",
        "nombre": "Laboratorios",
        "url": "/pdf/Convenios/Laboratorios.pdf"

    },
    {

        "icono": "Guarderias.png",
        "nombre": "Guarderias",
        "url": "/pdf/Convenios/Guarderias.pdf"

    },
    {

        "icono": "Preescolar.png",
        "nombre": "Preescolar",
        "url": "/pdf/Convenios/Preescolar.pdf"

    },

    {

        "icono": "Primarias.png",
        "nombre": "Primarias",
        "url": "/pdf/Convenios/Primarias.pdf"

    },
    {

        "icono": "Secundarias.png",
        "nombre": "Secundarias",
        "url": "/pdf/Convenios/Secundarias.pdf"

    },
    {

        "icono": "Bachilleratos.png",
        "nombre": "Bachilleratos",
        "url": "/pdf/Convenios/Bachilleratos.pdf"

    },
    {

        "icono": "Licenciaturas.png",
        "nombre": "Licenciaturas y Posgrados",
        "url": "/pdf/Convenios/Licenciaturas.pdf"

    },
    {

        "icono": "Cursos.png",
        "nombre": "Educación Técnica y Cursos",
        "url": "/pdf/Convenios/Educacion_tecnica_y_cursos.pdf"

    },

]

